"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavListWithImage = NavListWithImage;
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/styles");
const index_1 = require("../../index");
const variables_1 = __importDefault(require("../../styles/variables"));
const SplitWithImage_1 = require("../SplitWithImage/SplitWithImage");
const Text_1 = __importDefault(require("../Text"));
const core_1 = require("@material-ui/core");
const useStyles = (0, styles_1.makeStyles)({
    title: {
        marginBottom: variables_1.default.spacing(4),
        fontWeight: variables_1.default.fonts.weight.semiBold,
        wordWrap: 'break-word',
    },
});
function NavListWithImage({ title, items, ...rest }) {
    const classes = useStyles();
    const [seletedItemIndex, setSelectedItemIndex] = (0, react_1.useState)(0);
    return (react_1.default.createElement("div", { ...rest },
        react_1.default.createElement(SplitWithImage_1.SplitWithImage, { leftGridSize: 4, rightGridSize: 5, spacing: 3, "data-testid": "navlistwithimage-wrapper", imageUrl: items[seletedItemIndex].imageUrl, imageAltText: items[seletedItemIndex].listItem, mdDownHide: true },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Text_1.default, { as: "h3", className: classes.title }, title),
                react_1.default.createElement(index_1.NavList, { seletedIndex: seletedItemIndex, items: items.map((item) => item.listItem), onItemSelect: setSelectedItemIndex, "data-testid": "navigation-list" }))),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 3, justifyContent: "center", alignItems: "stretch" },
            react_1.default.createElement(core_1.Grid, { item: true, sm: 1 }, ' '),
            react_1.default.createElement(core_1.Hidden, { mdDown: true },
                react_1.default.createElement(core_1.Grid, { item: true, sm: 5 }, ' ')),
            react_1.default.createElement(core_1.Grid, { item: true, sm: 5 },
                react_1.default.createElement("div", null, items[seletedItemIndex].capabilityDetails)),
            react_1.default.createElement(core_1.Grid, { item: true, sm: 1 }, ' '))));
}
